import { render, staticRenderFns } from "./ShareGroups.vue?vue&type=template&id=0f3a5feb&scoped=true&"
import script from "./ShareGroups.vue?vue&type=script&lang=js&"
export * from "./ShareGroups.vue?vue&type=script&lang=js&"
import style0 from "./ShareGroups.vue?vue&type=style&index=0&id=0f3a5feb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3a5feb",
  null
  
)

export default component.exports